// extracted by mini-css-extract-plugin
module.exports = {"grids":"quality-assurance_grids__Ptl7F"};